import "core-js/modules/es.string.link.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import useBreakpoints from 'hooks/useBreakpoints';
import Button from 'components/Button';
import Text from 'components/Text';
import Flex from 'components/Flex';
import Box from 'components/Box';
import Card from 'components/Card';
import TextLink from 'components/TextLink';
import PercentageDisc from 'components/PercentageDisc';
function MeetingItem(_ref) {
  var score = _ref.score,
    title = _ref.title,
    subtitle = _ref.subtitle,
    link = _ref.link;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useBreakpoints = useBreakpoints(),
    isDesktopOrTablet = _useBreakpoints.xs;
  return /*#__PURE__*/React.createElement(Card, {
    variant: "clickable",
    px: "m",
    py: 12,
    position: "relative"
  }, /*#__PURE__*/React.createElement(Flex, {
    flexDirection: "row"
  }, /*#__PURE__*/React.createElement(Flex, {
    flexDirection: "row",
    grow: true,
    shrink: true,
    gap: "m"
  }, (score || score === 0) && /*#__PURE__*/React.createElement(PercentageDisc, {
    size: "small",
    shady: true,
    percentage: score
  }), /*#__PURE__*/React.createElement(TextLink, {
    bold: true,
    as: Link,
    to: link
  }, t(title), /*#__PURE__*/React.createElement(Box
  // Extend clickable area across whole banner
  , {
    fillParent: true
  })), isDesktopOrTablet && subtitle && /*#__PURE__*/React.createElement(Text, {
    overflow: "wrap",
    dimmed: true
  }, subtitle)), /*#__PURE__*/React.createElement(Button, {
    iconOnly: true,
    icon: "arrow-right",
    size: "medium",
    variant: "transparent",
    as: Link,
    to: link
  }, t('actions_view_meeting', {
    name: title
  }))));
}
export default MeetingItem;